// extracted by mini-css-extract-plugin
export default {"agreement":"Agreement_agreement__5x02o","checkbox":"Agreement_checkbox__3fplH","text":"Agreement_text__-GcuH"};